export enum Themes
{
	BasicHTML    = "basicHTML",
	BasicNoControlHTML    = "basicNoControlHTML",
	Material = "material",
	Semantic = "semantic",
}